import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FlattenedExamSession } from '../types/exam-types';
import {
  SectionHeader,
  SectionWrapper,
  EmptyState,
  sessionTypeTemplate,
  sessionDateTemplate,
  attendedTemplate,
  gradeTemplate,
} from './componenets/exam-shared-components';

interface HistoricalExamsProps {
  sessions: FlattenedExamSession[];
}

export const HistoricalExams: React.FC<HistoricalExamsProps> = ({
  sessions,
}) => {
  return (
    <SectionWrapper>
      <SectionHeader
        title="מבחנים היסטוריים"
        icon="pi pi-history"
        count={sessions.length}
        accentColor="#8B5CF6"
      />
      <div style={{ padding: '16px' }}>
        {sessions.length > 0 ? (
          <DataTable
            value={sessions}
            stripedRows
            showGridlines
            tableStyle={{ minWidth: '50rem' }}
          >
            <Column
              field="examName"
              header="שם המבחן"
              style={{ textAlign: 'right', fontWeight: 'bold' }}
            />
            <Column
              field="courseName"
              header="קורס"
              style={{ textAlign: 'right' }}
            />
            <Column
              header="מועד"
              body={sessionTypeTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="תאריך"
              body={sessionDateTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="נוכחות"
              body={attendedTemplate}
              style={{ textAlign: 'right' }}
            />
            <Column
              header="ציון"
              body={gradeTemplate}
              style={{ textAlign: 'right' }}
            />
          </DataTable>
        ) : (
          <EmptyState message="אין היסטוריית מבחנים" />
        )}
      </div>
    </SectionWrapper>
  );
};
